import React, { Component } from 'react';
import { Button, Container, Col, Row, Label} from 'reactstrap';
import { inject, observer } from 'mobx-react';
import FiltrosOrcamentoImport from '../components/FiltrosOrcamentoImport';
import DadosProcesso from '../components/DadosProcesso';
import ResultadoPesquisa from '../components/ResultadoPesquisa';
import TabelaOrcamentoImport from '../components/TabelaOrcamentoImport';
import OrcamentoImportStore from '../stores/OrcamentoImportStore';
import Footer from '../../../../comum/components/Footer';
import FooterContent from '../../../../comum/components/FooterContent';
import FooterOptions from '../../../../comum/components/FooterOptions';
import ModalDadosRetirada from '../components/ModalDadosRetirada';
import LoadingImage from '../../../../comum/components/LoadingImage';
import ModalDadosCIF from '../components/ModalDadosCIF';
import ModalForm from '../../../../comum/components/ModalForm';
import ModalPix from '../../../../comum/components/ModalPix';
import ModalArmazenamento from '../components/ModalArmazenamento';
import ModalAviso from '../../../../comum/components/ModalAviso';
import FormInputSimples from '../../../../comum/components/FormInputSimples';


@inject("store")
@observer
export class OrcamentoImport extends Component {
    
    constructor(props) {
        super(props)

        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.consultaController = this.props.controller;

        this.controller = new OrcamentoImportStore();

        this.renderEmpty = this.renderEmpty.bind(this);
    }
    
    componentDidMount() {
        
        this.appStore.showVoltarTopBar(true, '/consulta-orcamentos',null, this.consultaController.fecharTelaImportExport);
        this.tituloPaginaStore.setTitulo("Orçamento de Importação");
        
    }

    componentWillUnmount() {
        this.appStore.showVoltarTopBar(false);
        this.tituloPaginaStore.setTitulo("Orçamentos");
        this.consultaController.fecharModalNovoOrcamento()
    }

    renderModalPagamento() {
        if(this.controller.naoGeraBoleto){
            return this.controller.modalPagamento && <ModalAviso
                        onClickFechar={this.controller.fecharModalPagamento}
                    >
                        <h2>Não é possível gerar a cobrança para este documento. Aguarde a averbação do processo.</h2>
                    </ModalAviso>
        } else {
            return this.controller.modalPagamento && <ModalForm
                onClickCancelar={this.controller.fecharModalPagamento}
                onClickSalvar={() => {
                    if(this.controller.tipoPagamento == 0) this.controller.gerarBoleto();
                    else this.controller.gerarPix(); 
                }}
                salvando={this.controller.loadingBoleto}
                labelConfirmar="SIM"
                labelCancelar="NÃO"
                className="tamanho-modal-500"
                >
                <h2>
                    {(this.controller.tipoPagamento == 0) ? "Gerar boleto" : "Gerar PIX"}
                </h2>
                <Col>
                    <Row className="py-0">
                        <Label>As NF serão emitidas para o cliente abaixo e não serão canceladas após a emissão.</Label>
                    </Row>
                    <Row>
                        <Col className="card-detalhe">
                            <div className="card-detalhe--conteudo">
                                <h5>
                                    Cliente
                                </h5>
                                <div className="desc2">
                                    {this.controller.blDiInfo.RazaoCliente}
                                </div>
                            </div>
                        </Col>
                        <Col className="card-detalhe">
                            <div className="card-detalhe--conteudo">
                                <h5>
                                    CNPJ
                                </h5>
                                <div className="desc2">
                                    {this.controller.blDiInfo.CgcCliente}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    { process.env.rig && <Row className="mt-0">
                        <span style={{color:'#758290'}}>
                            Se o cliente estiver diferente, favor cancelar o orçamento e contactar o setor de atendimento comercial, Import Desk para correção.
                        </span>
                    </Row>}
                    { process.env.ssa && <Row className="mt-0">
                        <span style={{color:'#758290'}}>
                            Se o cliente estiver diferente, favor cancelar o orçamento e contactar o setor de Atendimento ao Cliente para correção.
                        </span>
                    </Row>}
                    <Row className="p-0">
                        <FormInputSimples xs={12} sm={12} md={12} lg={12} xl={12}
                                          titulo="Referência cliente" 
                                          className="p-0"
                                          extraInfo={process.env.ssa ? "Se desejar, informe o PO" :""}
                                          extraInfoSmaller={process.env.ssa ? true : false}
                                          dado={this.controller.refCliente} 
                                          onChange={(event) => this.controller.setRefCliente(event.target.value)} 
                        />
                    </Row>                    
                    <Row className="mr-auto">
                        <b style={{color:'#758290'}}>
                            Deseja continuar?
                        </b>
                    </Row>
                </Col>
            </ModalForm> 
        }
    }

    renderModalPagamentoPix() {
        return this.controller.modalPagamentoPix && 
            <ModalPix 
                consultaController={this.consultaController}
                controller={this.controller}
                valorTotal={this.controller.totalPagamento}
                dataPix={this.controller.dataPix} 
            />
    }

    renderModalRetirada() {
        return this.controller.modalRetirada && <ModalDadosRetirada controller={this.controller} />
    }

    renderModalCalculo() {
        return this.controller.modalCalcular && <ModalDadosCIF controller={this.controller} />
    }

    renderModalArmazenagem() {
        return this.controller.modalArmazenamento && <ModalArmazenamento controller={this.controller} />
    }

    renderEmpty() {
        if(this.controller.loading) {
            return <LoadingImage />
        } else if(!this.controller.filtrado || this.controller.tableMessage !== "") {
            return (<Row>
                <Col>
                    <span className="mensagem-filtrar">{this.controller.tableMessage}</span>
                </Col>
            </Row>)
        }
    }

    modalAlerta() {
        return this.controller.alerta && <ModalAviso
            onClickFechar={this.controller.fecharModalAviso}
        >
            <h2>{ this.controller.alerta }</h2>
        </ModalAviso>
    }

    modalAviso() {
        return this.controller.mensagem !== "" && 
        <ModalAviso
            onClickFechar={this.controller.fecharModalMensagem}
        >
            <h2>{this.controller.mensagem}</h2>
        </ModalAviso>
    }

    modalTempSSA() {
        return this.controller.modalTempSSA && 
        <ModalForm   className="tamanho-modal-acomproc" 
                            esconderSalvar={true}
                            onClickCancelar={() => this.controller.modalTempSSA = false}                                
                            labelCancelar="FECHAR" 
                >
                            <p className="text-desistencia">
                            <strong>Atenção!</strong><br/><br/>
                            1. Os cálculos são estimados, sujeito a alteração, caso algum serviço seja executado posteriormente e/ou houver períodos adicionais.
                            <br/><br/>2. O pagamento do boleto deverá ser realizado um dia útil anterior à retirada da carga devido a compensação bancária. 
                            <br/><br/>3. A Nota fiscal será emitida automaticamente após a compensação bancária do boleto (dia posterior ao pagamento). Não serão aceitos crédito em conta corrente.
                            <br/><br/>4. Caso a DI - Declaração de Importação - ainda não tenha sido registrada, não será possível geração de boleto. Somente a simulação do cálculo.
                            <br/><br/>Nota: Os presentes valores consideram estimativas comerciais, tratando-se de informação disponível para simples conferência, reservando-se ao Tecon o direito de promover alterações comerciais aplicáveis. Destacamos a importância de consulta aos termos da proposta comercial negociada ou Tabela Pública do Terminal, disponível em nosso Portal https://www.wilsonsons.com.br/pt/teconsalvador. Para avaliação dos parâmetros comerciais, bem como em caso de divergências nos valores apresentados, solicitamos acionar o canal de atendimento ao cliente, disponibilizado no sítio em referência.                   
                            </p>
        </ModalForm>
    }

    modalDemonstrativo() {
        if(this.controller.loadingDemonstrativo) {
            return (
                <ModalAviso
                    onClickFechar={() => {this.controller.loadingDemonstrativo = false}}
                >
                    <h2>
                        Processando
                    </h2>
                    <LoadingImage />
                </ModalAviso>
            )
        }
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.modalAlerta()}
                {this.modalAviso()}
                {this.modalTempSSA()}
                {this.modalDemonstrativo()}
                {this.renderModalPagamento()}
                {this.renderModalPagamentoPix()}
                {this.renderModalRetirada()}
                {this.renderModalArmazenagem()}
                {this.renderModalCalculo()}
                <Container className="liberacao-cabotagem" fluid style={{marginBottom:'115px'}}>
                    <FiltrosOrcamentoImport controller={this.controller} />
                    {
                        (this.controller.loading || this.controller.tableMessage !== "" || !this.controller.filtrado)
                        ? this.renderEmpty()
                        :<React.Fragment>
                            <DadosProcesso controller={this.controller} />
                            {!process.env.rig && <ResultadoPesquisa controller={this.controller}/>}
                            <TabelaOrcamentoImport controller={this.controller} />
                        </React.Fragment>
                    }
                </Container>
                <Footer>
                    <FooterContent>
                        {
                        window.innerWidth > 850 && this.controller.filtrado
                        ?<React.Fragment>
                            <b>
                                {this.controller.listaServicos.length}
                            </b> Solicitações registradas
                            -
                            <Button className="btn-primary px-0" onClick={this.controller.pesquisar}>Atualizar lista</Button>
                        </React.Fragment>
                        : null
                    }
                       
                    </FooterContent>
                    {
                    this.controller.filtrado && this.controller.tabelaDados.length > 0
                    ?<FooterOptions>
                        <div className="total-pagamento">
                            Total
                        </div>
                        <div className="box-valor">
                            {this.controller.totalFaturar.toLocaleString('pt-BR',{style: 'currency', currency: 'BRL', minimumFractionDigits: 2})}
                        </div>
                        <div className="total-pagamento">
                            A faturar
                        </div>
                        <div className="box-valor">
                            {this.controller.calculaTotal()}
                        </div>
                    </FooterOptions>
                    :null
                    }
                    <FooterContent className="right-pos">
                        <Button
                            onClick={() => {
                                this.controller.tipoPagamento = 1;
                                this.controller.abrirModalPagamento();
                            }}
                            className="btn-primary"
                            disabled={this.controller.listaSelecionados.length === 0}
                        >
                            PAGAMENTO COM PIX
                        </Button>
                        <Button
                            onClick={() => {
                                this.controller.tipoPagamento = 0;
                                this.controller.abrirModalPagamento();
                            }}
                            className="btn-primary"
                            disabled={this.controller.listaSelecionados.length === 0}
                        >
                            GERAR BOLETO
                        </Button>
                    </FooterContent>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/telas/OrcamentoImport.js